module.exports = __webpack_public_path__ + "static/media/banner-amazon-6pay.e62cb574.png";